import React, { useState, useRef } from 'react';
export function TransformationSlider() {
  const [sliderPos, setSliderPos] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleMove = (clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const position = x / rect.width * 100;
    setSliderPos(Math.min(Math.max(position, 0), 100));
  };
  const onPointerDown = (e: React.PointerEvent) => {
    ;
    (e.target as HTMLElement).setPointerCapture(e.pointerId);
    setIsDragging(true);
    handleMove(e.clientX);
  };
  const onPointerMove = (e: React.PointerEvent) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };
  const onPointerUp = (e: React.PointerEvent) => {
    setIsDragging(false);
  };
  return <section className="py-12 px-6 bg-white border-y-3 border-charcoal" data-id="element-156">
      <div className="max-w-7xl mx-auto" data-id="element-157">
        <div className="text-center mb-8" data-id="element-158">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-159">
            The Power of Refacing
          </h2>
          <p className="text-charcoal/60 max-w-2xl mx-auto" data-id="element-160">
            See the 48-hour transformation from outdated oak to modern luxury.
          </p>
        </div>

        <div ref={containerRef} onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerUp} onPointerCancel={onPointerUp} className="relative aspect-[4/3] md:aspect-[21/9] w-full overflow-hidden border-3 border-charcoal select-none bg-charcoal cursor-ew-resize touch-none" data-id="element-161">
          {/* Before Image (Bottom Layer) */}
          <div className="absolute inset-0" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/fBtncLzLutrQEqaBJZSN3j/Screenshot_2026-05-22_223402.png" alt="Before Refacing" className="w-full h-full object-cover brightness-[0.9]" draggable={false} data-id="element-163" />
            <div className="absolute bottom-8 left-8 bg-charcoal/80 backdrop-blur-sm text-alabaster px-4 py-2 font-bold uppercase tracking-widest text-[10px] md:text-xs z-0 border border-white/10" data-id="element-164">
              Before: Outdated Oak
            </div>
          </div>

          {/* After Image (Top Layer, Clipped) */}
          <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden border-r-4 border-white shadow-[5px_0_15px_rgba(0,0,0,0.3)]" style={{
          width: `${sliderPos}%`
        }} data-id="element-165">
            <div className="absolute inset-0 w-[calc(100vw-48px)] md:w-[calc(100vw-96px)] lg:w-[1280px] h-full" data-id="element-166">
              <img src="https://cdn.magicpatterns.com/uploads/52StWZAr3XMHFp5BKXskgs/Screenshot_2026-05-22_223422.png" alt="After Refacing" className="w-full h-full object-cover" draggable={false} data-id="element-167" />
            </div>
            <div className="absolute bottom-8 left-8 bg-espresso text-alabaster px-4 py-2 font-bold uppercase tracking-widest text-[10px] md:text-xs whitespace-nowrap border border-white/10" data-id="element-168">
              After: Modern White Reface
            </div>
          </div>

          {/* Visual Handle Circle */}
          <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-12 h-12 bg-espresso rounded-full border-4 border-white z-20 pointer-events-none shadow-xl flex items-center justify-center" style={{
          left: `${sliderPos}%`
        }} data-id="element-169">
            <div className="flex gap-1" data-id="element-170">
              <div className="w-1 h-4 bg-white/40 rounded-full" data-id="element-171" />
              <div className="w-1 h-4 bg-white/40 rounded-full" data-id="element-172" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}